import { render, staticRenderFns } from "./ReportEncargado.vue?vue&type=template&id=70dce0e6&scoped=true"
import script from "./ReportEncargado.vue?vue&type=script&lang=js"
export * from "./ReportEncargado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dce0e6",
  null
  
)

export default component.exports